import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";
import { MessageResponse } from "./physicalTechnicalVerifications";

export enum DisbursementBeneficiaryType {
    BORROWER = "BORROWER",
    SELLER = "SELLER",
    DEVELOPER = "DEVELOPER",
    MERCHANT = "MERCHANT",
    INSTITUTION = "INSTITUTION",
    INSURER = "INSURER",
    ESCROW_OR_PARTNER = "ESCROW_OR_PARTNER",
    OTHER = "OTHER",
}

export enum DisbursementFundsTransferMode {
    NEFT = "NEFT",
    RTGS = "RTGS",
    IMPS = "IMPS",
    ACCOUNT_PAYEE_CHEQUE = "ACCOUNT_PAYEE_CHEQUE",
    INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
    DEMAND_DRAFT = "DEMAND_DRAFT",
    UPI = "UPI",
    OTHER = "OTHER",
}

export interface DisbursementFields {
    loan_account_number: string;
    disbursement_date: string;
    beneficiary_type: DisbursementBeneficiaryType;
    funds_transfer_mode?: DisbursementFundsTransferMode | null;
    recipient?: string | null;
    disbursement_amount: number;
    remarks?: string | null;
}

export interface DisbursementEntity extends DisbursementFields {
    disbursement_id: string;
}

export interface GetDisbursementsResponse {
    disbursements: DisbursementEntity[];
}

export interface UpsertDisbursementsRequest {
    disbursements: DisbursementEntity[];
}

export interface GetDisbursementsParams {
    case_id: string;
}

export interface UpsertDisbursementsParams {
    case_id: string;
    request: UpsertDisbursementsRequest;
}

const DisbursementsAPI = {
    getDisbursements: async (params: GetDisbursementsParams) => {
      const response: AxiosResponse<GetDisbursementsResponse> =
        await axiosInstance.get(`/v1/cases/${params.case_id}/disbursements`);

      return response.data;
    },

    upsertDisbursements: async (params: UpsertDisbursementsParams) => {
      const response: AxiosResponse<MessageResponse> = await axiosInstance.put(
        `/v1/cases/${params.case_id}/disbursements`,
        params.request,
      );

      return response.data;
    },
};

export default DisbursementsAPI;
